export default "__VITE_ASSET__b533c8a3__"